/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import PageWrapper from '../components/PageWrapper';
import { Link } from 'gatsby'
import Helmet from "react-helmet";
import * as style from './about.module.css';

const About = () => {
  return (
    <PageWrapper>
      <Helmet>
        <title>サークル概要 | ちぇるのやるすく工廠</title>
        <meta name="description" content="サークルの概要です" />
        <html lang="ja" />
      </Helmet>
      <h1>サークル『ちぇるのやるすく工廠』とは？</h1>
      <h4>
        本サークル『ちぇるのやるすく工廠』は主に同人誌（漫画）を制作しております。
      </h4>
      {/* <div style={{ textAlign: "center" }} >
          <Link title="”とんだ”ご挨拶だな！" to="/member"><ButtonPrimary>工廠長ご挨拶</ButtonPrimary></Link>
        </div>
        <br /> */}
      <h2>沿革</h2>
      <div className={style.cell}>
        <input id="flag1" className={style.check} type="checkbox" />
        <label className={style.cellSw} for="flag1"><span className={style.cellSign}>▼</span>　ガルパン・ドルフロ二次創作（2016年〜2022年）</label>
        <div className={style.content}>
          <table >
            <tr>
              <td>2016/5/2</td><td>ツイッターアカウント作成、サークル設立、ペンネーム『ЧЕР』でサークル活動を開始、
                主に『ガールズ＆パンツァー』の二次創作活動を行う</td>
            </tr>
            <tr>
              <td>2017/1</td><td><a rel="noopner" target="_blank" href="https://www.pixiv.net/users/6102934">だっち氏</a>主催の『ガールズ＆パンツァー』二次創作<a rel="noopner" target="_blank" href="https://twipla.jp/events/237246">河嶋桃本</a>に寄稿</td>
            </tr>
            <tr>
              <td>2017/1/22</td><td>『ぱんっあ☆ふぉー！9』において『ガールズ＆パンツァー』二次創作のサークル初同人誌『<a rel="noopner" target="_blank" href="https://www.dlsite.com/home/work/=/product_id/RJ260724.html">ガルパン珍食記 ネオスシバー炎上</a>』を頒布</td>
            </tr>
            <tr>
              <td>2017/2</td><td>2017/9/23発行・<a rel="noopner" target="_blank" href="https://www.pixiv.net/users/155016">乃子氏</a>主催の
                『ガールズ＆パンツァー』二次創作ルクリリ合同誌『<a rel="noopner" target="_blank" href="https://www.melonbooks.co.jp/detail/detail.php?product_id=286156">RUKURIRI FANBOOKS</a>』に寄稿</td>
            </tr>
            <tr>
              <td>2017/4</td><td>多忙のためサークル活動を停止</td>
            </tr>
            <tr>
              <td>2018/11/5</td><td>１月に削除してしまった以前のIDでツイッターを再開、ペンネームを『HTKN』とし、『ドールズフロントライン』の二次創作活動を開始</td>
            </tr>
            <tr>
              <td>2019/6/30</td><td>再開後初、『少女戦略最前線04』において『ドールズフロントライン』二次創作１作目の同人誌『<a title="買ってね" rel="noopner" target="_blank" href="https://htkn.booth.pm/items/2272379">ドルフロシアン Avant-Garde</a>』を頒布</td>
            </tr>
            <tr>
              <td>2019/9/22</td><td>『少女戦略最前線05』において『ドールズフロントライン』二次創作２作目の同人誌『<a title="買って〜" rel="noopner" target="_blank" href="https://htkn.booth.pm/items/2355651">AS-Valちゃん、新しいクマよ！</a>』を頒布</td>
            </tr>
            <tr>
              <td>2020/2/12</td><td>2020/10発行・<a rel="noopner" target="_blank" href="https://twitter.com/_KINAKO_PAN_">ツチノコ スネーク氏</a>主催の『ドールズフロントライン』二次創作自衛隊合同誌
                『<a rel="noopner" target="_blank" href="https://twipla.jp/events/429022">こちら極東方面大東亜地区日ノ本駐屯地　混成団</a>』に寄稿</td>
            </tr>
            <tr>
              <td>2020/9/22</td><td>『少女戦略最前線06』において『ドールズフロントライン』二次創作３作目の同人誌『<a title="買ってください……" rel="noopner" target="_blank" href="https://htkn.booth.pm/items/2400820">ドルフロート・アルミー・フラクチオン</a>』を頒布</td>
            </tr>
            <tr>
              <td>2020/12/18</td><td>サークルポータルサイトをリリース</td>
            </tr>
            <tr>
              <td>2021/4/18</td><td>『<Link to="/blog/20210419d1">硝煙の乙女</Link>』において『ドールズフロントライン』二次創作４作目の同人誌『<a rel="noopner" target="_blank" href="https://htkn.booth.pm/items/2887569">ドルフロレタリアンズ、ユナイト！</a>』を頒布</td>
            </tr>
            <tr>
              <td>2021/9/19</td><td>『<a rel="noopner" target="_blank" href="https://www.youyou.co.jp/only/syoen/2/">硝煙の乙女2</a>』において『ドールズフロントライン』二次創作５作目(番外編)『ドルフロシアン EX.』を頒布</td>
            </tr>
            <tr>
              <td>2022/2/6</td><td>『<a rel="noopner" target="_blank" href="http://aiutoclub.com/glrv/glrv_top.html">少女戦略最前線REVENGE</a>』において『ドールズフロントライン』二次創作を頒布</td>
            </tr>
          </table>
          <label className={style.cellSw} for="flag1"><span className={style.cellSign}>▲</span> 閉じる</label>
        </div>
      </div>
      <div className={style.cell}>
        <input id="flag2" className={style.check} type="checkbox" checked />
        <label className={style.cellSw} for="flag2"><span className={style.cellSign}>▼</span>　オリジナル（2022年〜）</label>
        <div className={style.content}>
          <table>
            <tr>
              <td>2022/5/5</td><td>『<a rel="noopner" target="_blank" href="https://www.comitia.co.jp/">コミティア140</a>』において漫画『<a rel="noopner" target="_blank" href="https://htkn.booth.pm/items/3816645">セレブリャニエ・ストレーリ 1</a>』を頒布</td>
            </tr>
            <tr>
              <td>2023/2/19</td><td>『<a rel="noopner" target="_blank" href="https://www.comitia.co.jp/">コミティア143</a>』において漫画『<a rel="noopner" target="_blank" href="https://htkn.booth.pm/items/4526577">セレブリャニエ・ストレーリ 2</a>』を頒布</td>
            </tr>
            <tr>
              <td>2024/8/12</td><td>『コミックマーケット104』において漫画『<a rel="noopner" target="_blank" href="https://htkn.booth.pm/items/5920480">セレブリャニエ・ストレーリ 3</a>』を頒布</td>
            </tr>
          </table>
        </div>
      </div>
      <div className={style.cell}>
        <input id="flag3" className={style.check} type="checkbox" checked />
        <label className={style.cellSw} for="flag3"><span className={style.cellSign}>▼</span>　ブルアカ二次創作（2023年〜）</label>
        <div className={style.content}>
          <table>
            <tr>
              <td>2024/1/20</td><td>ブルアカオンリー即売会『<a rel="noopner" target="_blank" href="https://checow.com/event/sanctum">Sanctum Archive chapter.4</a>』においてまとめ本『<a rel="noopner" target="_blank" href="https://htkn.booth.pm/items/5406985">Remarkable Choices Assortment</a>』を頒布</td>
            </tr>
            <tr>
              <td>2024/8/11</td><td><a rel="noopner" target="_blank" href="https://x.com/f2_z2_r6_MRN">ふづる</a>氏主催の池倉マリナ合同誌『マリナはかわいい！』に漫画を寄稿</td>
            </tr>
          </table>
        </div>
      </div>
      {/* 
      <div className={style.cell}>
        <input id="flag4" className={style.check} type="checkbox" checked />
        <label className={style.cellSw} for="flag4"><span className={style.cellSign}>▼</span>　その他</label>
        <div className={style.content}>
          <table>
            <tr>
              <td>2024/9/7</td><td>配信者「<a rel="noopner" target="_blank" href="https://www.twitch.tv/nekosui_maro">猫吸まろ</a>」様のマネージャー（Discordサーバー管理、配信モデレーター）就任</td>
            </tr>
            <tr>
              <td>2024/8/11</td><td><a rel="noopner" target="_blank" href="https://x.com/f2_z2_r6_MRN">ふづる</a>氏主催の池倉マリナ合同誌『マリナはかわいい！』に漫画を寄稿</td>
            </tr>
          </table>
        </div>
      </div> */}
      <br />
      <h2>連絡先</h2>
      <p>以下のいずれかで受け付けます。<br />
        万が一弊サークルの制作物に不備があった場合はぜひご連絡ください。対応いたします。</p>
      <ul>
        <li>
          <a
            title="Link to our Twitter account"
            href='https://twitter.com/chern0yarsk'
            target="_blank"
            rel="noopener noreferrer">
            ツイッター(DM可、24/5/26にアカウント凍結のため作り直しました)
          </a>
        </li>
        <li>
          <a
            title="Link to our Discord account"
            href='https://discordapp.com/users/533980204390023178'
            target="_blank"
            rel="noopener noreferrer">
            Discord：htkn
          </a>
        </li>
      </ul>
    </PageWrapper >
  );
};

export default About;
